import React from 'react';

import useRegionData from './useRegionData';
import setupGTMServerside from './initializeGTMServerside';

/*
So basically, Builder's GraphQL API won't let you query across Models. Instead, we query each Model.
The $path is unique (e.g. "/harrys/page-slug"), so there will only ever be 1 matching page in the pageQuery
response data. At this stage in the Serverside Rendering, Gatsby "doesn't know" what Model/brand each page
is associated with - that is parsed out of the location/document:
* location.href - Full URL; available clientside ONLY. Needed for Staging/Prod domains post-VCL
* location.pathname - Page path only; Needed for Published-at-least-once pages during SSR
* document.URL - Full URL; available clientside ONLY. used for Draft (never Published) pages

TODO - This file probably should be refactored
*/

// This needed to be added because this file is evaluated serverside AND clientside
// and on the staging domain it has /lpg/ instead of /harrys/
function matchBrand(pageUrl) {
  const brandObj = [
    [
      [
        '/harrys/',
        'harrys.com/lpg/',
        'harrys-stg-intl.global.ssl.fastly.net/lpg/',
      ],
      'harrys',
    ],
    [
      [
        '/lume/',
        'lumedeodorant.com/lpg/',
      ],
      'lume',
    ],
    [
      [
        '/mando/',
        'shopmando.com/lpg/',
      ],
      'mando',
    ],
    [
      [
        '/kelly/',
        'havenhealthmd',
        'havenhealthmd.com',
        'www.havenhealthmd.com',
        'havenhealthmd.com/lpg/',
        'www.havenhealthmd.com/lpg/',
        'havenhealthmd.com/lpg/',
      ],
      'kelly',
    ],
    [
      [
        '/spruce/',
        'myspruceboost',
        'myspruceboost.com',
        'www.myspruceboost.com',
        'myspruceboost.com/lpg/',
        'www.myspruceboost.com/lpg/',
        'myspruceboost.com/lpg/',
      ],
      'spruce',
    ],
  ];
  for (var i = 0; i < brandObj.length; i++) {
    for (var j = 0; j < brandObj[i][0].length; j++) {
      if (pageUrl.includes(brandObj[i][0][j])) {
        if(brandObj[i][1] === 'kelly' || brandObj[i][1] === 'spruce') {
          return {
            brand: brandObj[i][1],
            modelName: brandObj[i][1],
          };
        } else {
          return {
            brand: brandObj[i][1],
            modelName: brandObj[i][1] + '-marketing-page',
          };
        }
      }
    }
  }
}

export function setupServersideConfig(data, location) {
  var pageUrl = location?.href || location?.pathname || document?.URL; // TODO - not ideal, worth refactoring. Can be simplified if this file is prevented from being run clientside.

  var { brand, modelName } = matchBrand(pageUrl);
  var pageRegion = 'US'; // Default to US region

  if (typeof data === 'undefined') {
    // it's a never-published Draft page. Default to US region.
  } else {
    var modelsQueried = Object.values(data?.allBuilderModels);
    var pageData = modelsQueried.find((el) => el !== null);
    pageData = pageData?.content;
  }

  var regionConfig = useRegionData(brand, pageRegion); // uses graphQL to pull data from the JSON files in the /data/region/ subdirectory

  regionConfig.country =
    pageRegion && pageRegion.includes('-')
      ? pageRegion.split('-')[0]
      : pageRegion;
  regionConfig.country = regionConfig.country.trim().toUpperCase();

  regionConfig.modelName = modelName;

  const { headGTMScript, bodyGTMIframe } = setupGTMServerside(
    regionConfig.tagContainerId
  );
  regionConfig.headGTMScript = headGTMScript; // Added to <head> via <script> in Helmet in marketingPage.jsx
  regionConfig.bodyGTMIframe = bodyGTMIframe; // Added to <body> via <noscript> in Main in Layout/index.jsx

  return { pageData, regionConfig };
}
